import { DataTestableQuery } from '@y42/data-test';
import { AbstractFeatureChildQueryEntityConfig, AbstractFeatureChildUIModel } from '@y42/feature';
import { AbstractGitEntityState } from '@y42/feature/git/state';
import { JobbableUIModel } from '@y42/job';

export abstract class ImpexChildQuery<
  State extends AbstractGitEntityState = AbstractGitEntityState,
  UIModel extends AbstractFeatureChildUIModel & JobbableUIModel = AbstractFeatureChildUIModel & JobbableUIModel,
> extends DataTestableQuery<State, UIModel> {
  constructor(protected readonly cfg: AbstractFeatureChildQueryEntityConfig<State, UIModel>) {
    super(cfg);
  }
}
